import { render, staticRenderFns } from "./Sentiment.vue?vue&type=template&id=94bf7542&scoped=true"
import script from "./Sentiment.vue?vue&type=script&lang=js"
export * from "./Sentiment.vue?vue&type=script&lang=js"
import style0 from "./Sentiment.vue?vue&type=style&index=0&id=94bf7542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf7542",
  null
  
)

export default component.exports